import React from 'react';
import { styled } from '@linaria/react';

import Demo from '@/components/Demo';

function FlexDemo({ children, centered, ...delegated }) {
  const id = React.useId().replace(/:/g, '');

  return (
    <StyledDemo
      {...delegated}
      id={`flex-demo-${id}`}
      outputWrapper={null}
      data-align={centered ? 'center' : 'stretch'}
    >
      {children}
    </StyledDemo>
  );
}

const StyledDemo = styled(Demo)`
  &[data-align='stretch'] {
    align-items: stretch;
  }
  &[data-align='center'] {
    align-items: center;
  }
`;

export default FlexDemo;
